// Common props used within the Address components for embedding address suggestions
export default {
  props: {
    // Autocomplete options for searching
    autocompleteOptions: {
      type: Object,
      default: () => {
        return {
          componentRestrictions: {
            country: 'AU'
          }
        }
      }
    },
    // Is loading
    searchLoading: {
      type: Boolean,
      default: false
    },
    suggestionsLabel: {
      type: String,
      default: 'Suggestions'
    },
    allowRefreshSuggestions: {
      type: Boolean,
      default: false
    },
    // Default suggestions when focused on the search box
    suggestions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  emits: ['loadSuggestions', 'refreshSuggestions']
}
